module.exports = __webpack_public_path__ + "img/google-analytics-4.13da99b6.png";